
export class SimLogQuery {

    constructor(public name: string, public condition: string, public result: string) {
    }
}
